/**
 * StatisticsPage root page for showing profile statistics
 *
 * CONTINUE HERE: https://medium.com/@bananaoomarang/handcrafting-an-isomorphic-redux-application-with-love-40ada4468af4
 * http://teropa.info/blog/2015/09/10/full-stack-redux-tutorial.html
 * https://jira.finn.no/secure/RapidBoard.jspa?rapidView=147&view=detail&selectedIssue=REC-789&quickFilter=773
 * https://github.com/rackt/react-router/blob/master/docs/guides/basics/RouteConfiguration.md
 * https://github.com/xgrommx/awesome-redux
 */
import React from 'react';
import PropTypes from 'prop-types';
import { fetchStatistics } from './actions/profileStatisticsActions';
import Spinner from '../../components/gfx/Spinner';
import ProfileStatisticsUI from './components/ProfileStatisticsUI';
import { extractNLastFollowersByDate } from './helpers';
import { connect } from 'react-redux';
import analytics, * as trackingTypes from '../../actions/analyticsActions';
import NoAccess from '../../components/messages/NoAccess';

const lastNDays = 14;

class ProfileStatisticsPage extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func,
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string,
            }),
        }),
        profileStatistics: PropTypes.object,
    };

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.dispatch(analytics(trackingTypes.VIEW_STATISTICS, { id }));
        this.props.dispatch(fetchStatistics(id));
    }

    render() {
        const { profileStatistics } = this.props;

        if (profileStatistics.error && profileStatistics.error.status === 403) {
            return <NoAccess />;
        }

        return profileStatistics.loaded ? (
            <ProfileStatisticsUI
                lastNDays={lastNDays}
                lastNFollowers={extractNLastFollowersByDate(
                    lastNDays,
                    profileStatistics.followersByDate
                )}
                profileStatistics={profileStatistics}
            />
        ) : (
            <div className="centerify">
                <Spinner />
            </div>
        );
    }
}

export default connect((state) => ({
    profileStatistics: state.profileStatistics,
}))(ProfileStatisticsPage);
